import '../css/next.css'

const NextPage = ({next}) => {
    return (
        <div className="Next" onClick={()=>next()} >
            <div className="load">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 18l8.5-6L6 6v12zm2-8.14L11.03 12 8 14.14V9.86zM16 6h2v12h-2z"/></svg>
                <span>Next Page</span>
            </div>
        </div>
    )
}

export default NextPage
